import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import { useState } from 'react';
import { useAccount } from '../../contexts/AccountContext';
import { useNotifications } from '../../contexts/NotificationContext';
import {
  deleteAllNotifications,
  deleteNotification,
  markAsRead,
} from '../../services/notificationService';
import type { NotificationProps } from './Notification';
import NotificationDrawer from './NotificationDrawer';

const NotificationBell = () => {
  const { account: user } = useAccount();
  const { notifications } = useNotifications();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
    for (const n of notifications) {
      if (!n.read && n.id && user) {
        markAsRead(user.uid, n.id);
      }
    }
  };

  const handleDelete = (id: string) => {
    if (user) {
      deleteNotification(user.uid, id);
    }
  };

  const handleDeleteAll = () => {
    if (user) {
      deleteAllNotifications(user.uid);
    }
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleDrawerOpen}>
        <Badge
          badgeContent={notifications.length}
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.9rem',
              height: '22px',
              minWidth: '22px',
            },
          }}
        >
          <NotificationsIcon sx={{ fontSize: '2.25rem' }} />
        </Badge>
      </IconButton>
      <NotificationDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        notifications={
          notifications
            .filter((n): n is typeof n & { id: string } => Boolean(n.id))
            .map((n) => ({
              id: n.id,
              title: n.title,
              message: n.message,
              timestamp: n.timestamp,
              read: n.read,
              link: n.link,
            })) as Omit<NotificationProps, 'onDelete'>[]
        }
        onDelete={handleDelete}
        onDeleteAll={handleDeleteAll}
      />
    </>
  );
};

export default NotificationBell;
